import i18next from 'i18next';

import {
  CheckMetadata,
  createSimpleCheckMetadataArray,
} from 'dashboard/components/ChecksTable/computeCheckMetadata';
import { IdDisallowedTypeDetection } from 'dashboard/models/check';
import {
  GOVERNMENT_ID_DESIGNATION_DISPLAY_STRINGS,
  GovernmentIdClass,
  GovernmentIdDesignation,
} from 'lib/constants/governmentIds';
import { tForGovernmentId } from 'lib/governmentId';

export const computeIdDisallowedTypeDetectionMetadata = (
  check: IdDisallowedTypeDetection,
): CheckMetadata => {
  const metadata = [];

  const {
    'country-code': countryCode,
    'detected-id-class': detectedIdClass,
    'detected-id-designations': detectedIdDesignations,
    'disallowed-id-designations': disallowedIdDesignations,
    'enabled-id-classes': enabledIdClasses,
    'selected-id-classes': selectedIdClasses,
  } = check.metadata || {};

  metadata.push(
    {
      label: 'Detected ID Type',
      value: detectedIdClass
        ? tForGovernmentId(
            i18next.getFixedT('en-US'),
            ['government-id.title'],
            countryCode,
            detectedIdClass as GovernmentIdClass,
          )
        : '-',
    },
    {
      label: 'Selected ID Type',
      value: selectedIdClasses
        ? selectedIdClasses
            .map((id) =>
              tForGovernmentId(
                i18next.getFixedT('en-US'),
                ['government-id.title'],
                countryCode,
                id,
              ),
            )
            .join(', ')
        : '-',
    },
    {
      label: 'Enabled ID Types',
      value: enabledIdClasses
        ? enabledIdClasses
            .map((id) =>
              tForGovernmentId(
                i18next.getFixedT('en-US'),
                ['government-id.title'],
                countryCode,
                id,
              ),
            )
            .join(', ')
        : '-',
    },
  );

  if (detectedIdDesignations) {
    metadata.push({
      label: 'Detected ID Designations',
      value: detectedIdDesignations
        .map(
          (designation: GovernmentIdDesignation) =>
            GOVERNMENT_ID_DESIGNATION_DISPLAY_STRINGS[designation],
        )
        .sort()
        .join(', '),
    });
  }

  if (disallowedIdDesignations) {
    metadata.push({
      label: 'Disallowed ID Designations',
      value: disallowedIdDesignations
        .map(
          (designation: GovernmentIdDesignation) =>
            GOVERNMENT_ID_DESIGNATION_DISPLAY_STRINGS[designation],
        )
        .sort()
        .join(', '),
    });
  }

  return {
    metadata: createSimpleCheckMetadataArray(metadata),
    hideIfVerificationPassed: false,
  };
};
